import React, { Component } from 'react';

import Dropdown from '../inputs/Dropdown';
import Card from '../Card';
import Signature from '../inputs/Signature';

import styles from './signatureCard.module.scss';

export default class SignatureCard extends Component {
  render() {
    const {
      name,
      header,
      users,
      dropdownName,
      onUserChange,
      userId,
      userDisabled,
      disabled,
      currentValue,
      ...props
    } = this.props;

    return (
      <Card showHeader title={header} name={name}>
        <div className={styles.signatureCard}>
          {dropdownName && (
            <Dropdown
              fieldLabel={dropdownName}
              options={users}
              handleChange={onUserChange}
              currentValue={userId}
              disabled={userDisabled}
              searchable
              name="approver"
            />
          )}
          {currentValue || !disabled ? (
            <div className="input">
              <label className={styles.label}>
                Any person who knowingly and with intent to defraud an insurer
                files a statement of claim containing false, inflated,
                incomplete, or misleading information is subject to prosecution
                and punishment for insurance fraud and may be subject to civil
                fines, criminal penalties, and denial of insurance benefits. By
                electronically submitting this form, I hereby attest that the
                information contained herein and attached in electronic format
                is accurate and correctly represents and warrants the
                truthfulness of the information provided.
              </label>
              <Signature
                currentValue={currentValue}
                disabled={disabled}
                {...props}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </Card>
    );
  }
}
